export default [
    "id",
    "product_code",
    "product_description",
    "ean",
    "height",
    "length",
    "width",
    "mounting_hole",
    "number_of_lamps",
    "type_of_lamp",
    "wattage",
    "temp_range",
    "wiring_diagram",
    "comment",

    "brand",
    
    "match.id",
    "type",
    "score",
    "_meta.score",
    "pk",
    "is_alternative_fit",
    "is_perfect_fit",
    "remarks",
    "remark",
    "driver_type",
    "ignitor",
    "lamp_current",
    "mains_voltage",
    "mains_frequency",
    "thermal_protection",
    "delta_temperature",
    "energy_efficiency",
    "life_class_tw",
    "pf_cap",
    "losses",
    "power_factor",
    "weight",
    "product_url"
]
